import { useEffect, useState } from "react";

export function useAnimatedToggle(open: boolean, durationMs = 220) {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(open);
  useEffect(() => {
    if (open) { setMounted(true); requestAnimationFrame(() => setVisible(true)); return; }
    setVisible(false);
    const t = window.setTimeout(() => setMounted(false), durationMs);
    return () => window.clearTimeout(t);
  }, [open, durationMs]);
  return { mounted, visible };
}
